import axios, { type CreateAxiosDefaults } from 'axios';

const API_URL = import.meta.env.VITE_API_URL || window.location.origin;

const config: CreateAxiosDefaults<any> = {
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
};
export const Axios = axios.create(config);

export async function getSubPrograms() {
  const url = '/subprogram-finder/get-data';
  try {
    const { data } = await Axios.get(url);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getFilters() {
  try {
    const { data } = await Axios.get('/subprogram-finder/get-filters');
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}
